import { POST, GET, GET_WITH_RETRY } from './index';

const tokendefault = 'vEAFKYIX7zZV6oIoi8B52rp2sbPyYrk8';

/**
 * PDPA Service - Handles all PDPA consent and policy API calls
 */
export const pdpaService = {
  /**
   * Fetch current active PDPA policy version
   * GET /pdpa/policy/current
   * @returns {Promise} {policyVersion, effectiveDate}
   */
  getCurrentPolicy: (token = tokendefault) =>
    GET_WITH_RETRY('/pdpa/policy/current', token).then((response) => {
      if (response.success && response.result?.policy) {
        return response.result.policy;
      }
      throw new Error(response.message || 'Failed to fetch policy');
    }),

  /**
   * Submit consolidated PDPA consent status
   * POST /pdpa/consent/log
   * @param {Object} payload
   * @returns {Promise}
   */
  submitConsent: (payload, token = tokendefault) => POST('/pdpa/consent/log', payload, token),

  /**
   * Get consent history for a customer (Admin only)
   * GET /pdpa/consent/history/:customerId
   * @param {string} customerId
   * @param {string} token - Admin JWT token
   * @returns {Promise}
   */
  getConsentHistory: (customerId, token) =>
    GET(`/pdpa/consent/history/${customerId}`, token).then((response) => {
      if (response.success && response.result?.history) {
        return response.result.history;
      }
      throw new Error(response.message || 'Failed to fetch consent history');
    }),

  /**
   * Export user data (Admin only)
   * GET /pdpa/rights/export/:customerId
   * @param {string} customerId
   * @param {string} token - Admin JWT token
   * @returns {Promise}
   */
  exportData: (customerId, token) =>
    GET(`/pdpa/rights/export/${customerId}`, token).then((response) => {
      if (response.success && response.result) {
        return response.result;
      }
      throw new Error(response.message || 'Failed to export data');
    }),

  /**
   * Delete user data (Admin only)
   * DELETE /pdpa/rights/delete/:customerId
   * Note: This requires a DELETE HTTP method. Currently using POST workaround.
   * @param {string} customerId
   * @param {string} reason
   * @param {string} token - Admin JWT token
   * @returns {Promise}
   */
  deleteData: (customerId, reason, token) =>
    POST(`/pdpa/rights/delete/${customerId}`, { reason }, token),
};
